import { WorkflowActionTypes } from 'src/app/models/RestApiCaller/Enums/workflow-action-types';
import { IActionData } from './action-data.interface';

/**
 * Représente la classe de base des données d'une action.
 */
export class BaseActionData implements IActionData {
    /**
     * Constructeur.
     * @param type : Type de l'action.
     */
    constructor(public type: WorkflowActionTypes) {}

    /**
     * Id de l'action.
     */
    id: number;
}
